import { cn } from '@/utils/cn';

export function Table({
  className,
  compact,
  ...props
}: React.TableHTMLAttributes<HTMLTableElement> & { compact?: boolean }) {
  return (
    <table
      className={cn('w-full border-collapse text-left', compact ? 'text-xs' : 'text-body-md', className)}
      {...props}
    />
  );
}

export function TableWrap({
  className,
  compact,
  children,
}: {
  className?: string;
  compact?: boolean;
  children: React.ReactNode;
}) {
  return (
    <div
      className={cn(
        'custom-scrollbar overflow-x-auto',
        compact && 'max-h-96 overflow-y-auto',
        className
      )}
    >
      {children}
    </div>
  );
}

export function TableHeader({ className, ...props }: React.HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead
      className={cn('border-b border-border bg-surface-header', className)}
      {...props}
    />
  );
}

export function TableRow({ className, ...props }: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr
      className={cn('border-b border-surface-muted transition-colors hover:bg-surface-muted', className)}
      {...props}
    />
  );
}

export function TableHead({ className, ...props }: React.ThHTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={cn(
        'sticky top-0 z-30 bg-surface-header px-3 py-2.5 text-label-md font-semibold uppercase tracking-[0.12em] text-foreground-subtle',
        className
      )}
      {...props}
    />
  );
}

export function TableCell({
  className,
  compact,
  ...props
}: React.TdHTMLAttributes<HTMLTableCellElement> & { compact?: boolean }) {
  return (
    <td
      className={cn(compact ? 'px-2 py-1.5' : 'px-3 py-2.5', 'text-foreground', className)}
      {...props}
    />
  );
}
